import { minLength } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const MinLength = BuildValidatorWithComparandDecorator<
  string,
  string,
  number
>(minLength, 'DX.FORMS.VALIDATION.ERRORS.MIN_LENGTH');
